import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import IconClose from 'components/Icons/IconClose'
import IconBack from 'components/Icons/IconBack'

interface ButtonBackProps {
  onClick: () => void
  close?: boolean
}

const ButtonBack: React.FC<ButtonBackProps> = (props) => {
  const { onClick, close } = props
  const { t } = useTranslation()
  return (
    <StyledButtonBack onClick={onClick} title={t('back')} type="button">
      {close ? <IconClose /> : <IconBack />}
    </StyledButtonBack>
  )
}

const StyledButtonBack = styled.button`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  z-index: 10;
  cursor: pointer;
`
export default ButtonBack
